import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { PanelContentContainer } from "~/OnboardingApp/components";
import { ContinueCta } from "./ContinueCta";
import { Description } from "./Description";
import { Title } from "./Title";

export const RightPanelSection: FC = () => {
  return (
    <PanelContentContainer pt={{ base: 0, md: "12rem" }}>
      <Title />
      <Flex direction="column" gap={6} w="full">
        <Description />
        <ContinueCta />
      </Flex>
    </PanelContentContainer>
  );
};
